const OFFICE_IMG = 'https://readdy.ai/api/search-image?query=cozy%20child%20psychologist%20evaluation%20room%20with%20wooden%20desk%2C%20colorful%20puzzle%20pieces%20and%20educational%20toys%2C%20warm%20natural%20light%2C%20professional%20yet%20playful%20office%20decor%2C%20comfortable%20chairs%20for%20family%20consultation%2C%20plants%20and%20soft%20furnishings&width=700&height=800&seq=office001&orientation=portrait';

const pillars = [
  {
    icon: 'ri-eye-line',
    title: 'Transparência',
    subtitle: 'Você entende cada etapa',
    desc: 'Explicamos todos os protocolos em linguagem acessível, para que você nunca sinta que está no escuro. Sem termos assustadores, sem surpresas.',
    badge: 'Tira o medo do desconhecido',
    color: 'text-teal',
    bg: 'bg-teal/5 border-teal/15',
    badgeBg: 'bg-teal/10 text-teal-dark',
  },
  {
    icon: 'ri-timer-line',
    title: 'Agilidade',
    subtitle: 'Seu tempo é precioso',
    desc: 'A Pré-Anamnese Digital permite que você preencha o histórico do seu filho em casa, com calma. Assim, a sessão presencial é dedicada 100% ao que importa: o acolhimento.',
    badge: 'Pré-Anamnese Digital',
    color: 'text-coral',
    bg: 'bg-coral/5 border-coral/15',
    badgeBg: 'bg-coral/10 text-coral-dark',
  },
  {
    icon: 'ri-road-map-line',
    title: 'Suporte Pós-Avaliação',
    subtitle: 'A ANÁLISE É CLÍNICA E PRECISA',
    desc: 'Após a devolutiva, você recebe guias práticos para a escola, modelos de carta para solicitar adaptações e checklists de rotina. Caminhamos juntos após a avaliação.',
    badge: 'Orientação Escolar Contínua',
    color: 'text-amber-600',
    bg: 'bg-amber-50 border-amber-100',
    badgeBg: 'bg-amber-100 text-amber-700',
  },
];

export default function BenefitsTable() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <span className="inline-block text-coral text-xs font-700 font-sans uppercase tracking-widest mb-3">
              Nosso Diferencial
            </span>
            <h2 className="font-serif text-3xl md:text-4xl font-600 text-navy mb-4 md:mb-5 leading-tight">
              Avaliação que respeita<br />
              <span className="text-teal">o tempo da sua família</span>
            </h2>
            <p className="text-slate-500 font-sans text-base leading-relaxed mb-8 md:mb-10">
              Cada detalhe do nosso processo foi pensado para reduzir a ansiedade e maximizar a qualidade 
              do cuidado oferecido à criança e à família.
            </p>

            <div className="space-y-4 md:space-y-5">
              {pillars.map((p) => (
                <div
                  key={p.title}
                  className={`border rounded-xl p-4 md:p-6 ${p.bg} transition-all duration-200 hover:shadow-sm`}
                >
                  <div className="flex items-start gap-3 md:gap-4">
                    <div className={`w-10 h-10 flex items-center justify-center rounded-lg bg-white shrink-0`}>
                      <i className={`${p.icon} ${p.color} text-lg`} />
                    </div>
                    <div className="flex-1">
                      <div className="flex flex-wrap items-center gap-2 md:gap-3 mb-1">
                        <h3 className="font-serif text-lg font-600 text-navy">{p.title}</h3>
                        <span className={`text-xs font-600 font-sans px-2.5 py-0.5 rounded-full ${p.badgeBg}`}>
                          {p.badge}
                        </span>
                      </div>
                      <p className="text-xs font-700 font-sans text-slate-400 uppercase tracking-wide mb-2">
                        {p.subtitle}
                      </p>
                      <p className="text-sm font-sans text-slate-500 leading-relaxed">{p.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative mt-8 lg:mt-0">
            <div className="w-full h-[320px] md:h-[480px] lg:h-[620px] rounded-3xl overflow-hidden">
              <img
                src={OFFICE_IMG}
                alt="Ambiente de avaliação acolhedor"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="hidden md:block absolute -bottom-6 -left-6 bg-white rounded-2xl p-5 border border-beige-dark max-w-[220px]">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-8 h-8 flex items-center justify-center bg-teal/10 rounded-lg">
                  <i className="ri-shield-check-line text-teal text-base" />
                </div>
                <span className="text-xs font-700 font-sans text-navy">Segurança LGPD</span>
              </div>
              <p className="text-xs font-sans text-slate-400 leading-relaxed">
                Seus dados e os do seu filho são protegidos com criptografia e total privacidade.
              </p>
            </div>
            <div className="hidden md:block absolute -top-6 -right-6 bg-coral text-white rounded-2xl p-5 max-w-[180px]">
              <p className="font-serif text-2xl font-700 mb-1">98%</p>
              <p className="text-xs font-sans font-300 opacity-90">das famílias relatam redução de ansiedade após a 1ª sessão</p>
            </div>
            {/* Mobile badges */}
            <div className="md:hidden mt-4 grid grid-cols-2 gap-3">
              <div className="bg-white rounded-xl p-4 border border-beige-dark">
                <div className="flex items-center gap-2 mb-1">
                  <i className="ri-shield-check-line text-teal text-sm" />
                  <span className="text-xs font-700 font-sans text-navy">Segurança LGPD</span>
                </div>
                <p className="text-xs font-sans text-slate-400 leading-relaxed">Dados protegidos com criptografia.</p>
              </div>
              <div className="bg-coral text-white rounded-xl p-4">
                <p className="font-serif text-xl font-700 mb-0.5">98%</p>
                <p className="text-xs font-sans font-300 opacity-90 leading-snug">redução de ansiedade após a 1ª sessão</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
